import { useEffect, useRef } from 'react';
import { runScriptsInSandbox } from '../lib/sandboxedAd';

let adCounter = 0;

const NativeAd = ({ className = '' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const el = containerRef.current;
    el.innerHTML = '';

    const uid = `native_${++adCounter}_${Math.random().toString(36).slice(2, 8)}`;
    const containerId = `container-8d4ee5c22a525308a31201b50bcadd46-${uid}`;

    const cleanup = runScriptsInSandbox(
      el,
      [{ src: `https://pl29101859.effectivecpmnetwork.com/8d4ee5c22a525308a31201b50bcadd46/invoke.js?t=${uid}` }],
      `<div id="${containerId}"></div>`
    );

    return cleanup;
  }, []);

  return (
    <div ref={containerRef} className={`w-full flex justify-center ${className}`} data-testid="native-ad" />
  );
};

export default NativeAd;
